import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function CategoryDropdown({ onSelect, selectedCategory }) {
    const [selectedItem, setSelectedItem] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);

    // Hardcoded categories
    const items = [
        { item_id: '', name: 'All' },
        { item_id: 'Turkey', name: 'Turkey' },
        { item_id: 'Bread', name: 'Bread' },
        { item_id: 'Sliced Bread', name: 'Sliced Bread' },
        { item_id: 'Half Loaf', name: 'Half Loaf' },
        { item_id: 'Pork', name: 'Pork' },
        { item_id: 'Chicken', name: 'Chicken' },
        { item_id: 'Breakfast', name: 'Breakfast' },
        { item_id: 'Condiments', name: 'Condiments' },
        { item_id: 'Fruit Cup', name: 'Fruit Cup' },
        { item_id: 'Fresh Fruit', name: 'Fresh Fruit' },
        { item_id: 'Juice', name: 'Juice' },
        { item_id: 'Snack', name: 'Snack' },
        { item_id: 'Beef', name: 'Beef' },
        { item_id: 'Seafood', name: 'Seafood' },
        { item_id: 'Milk_Dairy', name: 'Milk/Dairy' },
        { item_id: 'Dessert/Snack', name: 'Dessert/Snack' },
        { item_id: 'Vegetarian', name: 'Vegetarian' },
    ];

    useEffect(() => {
        // Find and set the selected item based on the prop
        const foundItem = items.find(item => item.name === selectedCategory);
        setSelectedItem(foundItem);
    }, [selectedCategory]);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setShowDropdown(false); // Close the dropdown after selection
        onSelect(item); // Inform the parent component about the selection
    };

    return (
        <div className="relative flex items-end space-x-4">
            <div className="flex-1">
                <label htmlFor="category" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Subcategory</label>
                <input
                    type="text"
                    id="category"
                    name="category"
                    value={selectedItem ? `${selectedItem.name}` : ''}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Select Category"
                    readOnly
                />
            </div>

            <button
                id="dropdownCategoryButton"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                type="button"
                onClick={toggleDropdown}
            >
                {selectedItem ? selectedItem.name : 'Select Subcategory'}
                <svg className="ml-2 w-4 h-4" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8l5 5 5-5" />
                </svg>
            </button>

            {showDropdown && (
                <div className="absolute z-10 mt-1 bg-white divide-y divide-gray-100 rounded shadow w-full dark:bg-gray-700" style={{ top: '100%', left: 0, maxHeight: '20rem', overflowY: 'auto' }}>
                    <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownCategoryButton">
                        {items.map((item) => (
                            <li key={item.item_id}>
                                <a
                                    href="#"
                                    className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-xs"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent the link from navigating
                                        handleSelectItem(item);
                                    }}
                                >
                                    {item.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

CategoryDropdown.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedCategory: PropTypes.string,
};

export default CategoryDropdown;
